import axios from '@/plugins/axios';

export default {
    namespaced: true,

    state: {
        entities: [],
        entitiesCount: 0,
        entity: {}
    },

    mutations: {
        SET_ENTITIES(state, payload) {
            state.entities = payload.results;
            state.entitiesCount = payload.total;
        },
        SET_ENTITY(state, payload) {
            state.entity = payload;
        },
        CLEAR_ENTITY(state) {
            state.entity = {};
        },
    },

    actions: {
        async fetch({ commit }, { page = 1, itemsPerPage = 15 }) {
            const { data } = await axios.get(`/admin/discounts`, { params: { page, itemsPerPage }});
            commit('SET_ENTITIES', data);
            return data;
        },
        async get({ commit }, { entity_id, id }) {
            const { data } = await axios.get(`/admin/discounts/${ id }`);
            commit('SET_ENTITY', data);
        },
        async save({ commit, state }) {
            let response = {};
            if(state.entity.id) {
                response = await axios.put(`/admin/discounts/${ state.entity.id }`, state.entity);
            } else {
                response = await axios.post(`/admin/discounts`, state.entity);
            }
            return response.data;
        },
        async delete({ commit }, { id }) {
            await axios.delete(`/admin/discounts/${ id }`);
        },
    },

    getters: {}
}
